<footer class="app-footer d-print-none">
  <span><a href="https://appworx.ph">Appworx</a> &copy; 2018. ver. {{appVersion}}</span>
  <span class="ml-auto">
    Powered by <a [href]="_env.company.website">{{ _env.company.name }}</a>
  </span>
</footer>
